<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="3">
            <a-form-model-item label="平台" prop="payType">
              <a-select v-model="formInline.payType" placeholder="请选择平台" style="width: 100px;">
                <a-select-option value="1">美团</a-select-option>
                <a-select-option value="2">抖音</a-select-option>
                <a-select-option value="3">快手</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="订单编号" prop="orderNo">
              <a-input v-model="formInline.orderNo" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="卡号" prop="cardNo">
              <a-input v-model="formInline.cardNo" placeholder="请输入"> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="核销时间" prop="createTime">
              <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange"  v-model="formInline.createTime"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="query">
                查询
              </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-col :span="6">
                <a-button style="margin-left: 10px" @click="resetForm">
                  重置
                </a-button>
              </a-col>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <verificationSlipOrderHomeContentTwo
          ref="aaa"
          :formInline="formInline"
        ></verificationSlipOrderHomeContentTwo>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import verificationSlipOrderHomeContentTwo from '@/views/orderManagement/verificationSlipOrderTwo/verificationSlipOrderContentTwo';
import { create } from 'js-md5';
export default {
  components: {
    verificationSlipOrderHomeContentTwo,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        cardNo: "",
        limit: 10,
        page: 1,
        startTime: null,
        endTime: null,
        payType: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      console.log('核销表单sumbit:',this.formInline);
    },
    resetForm() {
      this.formInline = {
        orderNo: "",
        cardNo: "",
        startTime: null,
        endTime: null,
        payType: "",
        createTime: "",
      };
      this.$refs.aaa.data = [];
      console.log('执行重置表单',this.formInline);

    },
    onChange(date, dateString) {
      console.log(date, dateString);
      this.formInline.startTime = dateString ? dateString[0] : "";
      this.formInline.endTime = dateString ? dateString[1] : "";
    },
    query() {
      // 重置页码为第一页
      this.formInline.page = 1;
      this.formInline.limit = 10;
      this.$refs.aaa.search();
    },
   
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/verificationSlipOrderTwo/verificationSlipOrderHomeTwo.vue